import React from "react";
import {concepts, Course, Group, User} from "fearless-common";
import {adminRoutes} from "../../../utils/routes";
import {BoxArrowUpRight} from "react-bootstrap-icons";
import {NoResultsDiv} from "fearless-common-ui";
import AdminGroupNameSpan from "../../../components/admin/label-spans/AdminGroupNameSpan";

/**
 * Renders the admin user affiliations tab with details of a user's courses and groups.
 * This component displays the educator courses, research teams, and course groups that the user belongs to.
 */
export default function AdminUserAffiliationsTab({ user }: {
  // The user object containing information about the user.
  user: User & { groups: Group[]; courses: Course[] };
}) {
  return (
    <>
      <h5>
        {user.courses?.length} courses&nbsp;
        <small className="text-muted">(as educator)</small>
      </h5>
      <p className="small line-height-1-2">
        Showing all the courses this user is an educator of. If the user
        is a student in the course, their course group will show up under teams.
      </p>
      <table className="table table-sm text-sm">
        <thead>
        <tr>
          <th>Name</th>
          <th>&nbsp;</th>
        </tr>
        </thead>
        <tbody>
        {user.courses?.length > 0 ? user.courses?.map((course) => (
          <tr key={course.id}>
            <td>{course.name}</td>
            <td>
              <a href={adminRoutes.course(course.id)}>
                <BoxArrowUpRight />
              </a>
            </td>
          </tr>
        )) : <tr><td colSpan={2}><NoResultsDiv>Not an educator in any courses</NoResultsDiv></td></tr>}
        </tbody>
      </table>

      <h5 className="mt-5">{user.groups?.length} {concepts.Groups.toLowerCase()} and course groups</h5>
      <p className="small line-height-1-2">
        Showing all the research teams and course groups this user is a member of.
      </p>
      <table className="table table-sm text-sm">
        <thead>
        <tr>
          <th>Name</th>
        </tr>
        </thead>
        <tbody>
        {user.groups?.length > 0 ? user.groups?.map((group) => (
          <tr key={group.id}>
            <td>
              <AdminGroupNameSpan group={group} />
            </td>
          </tr>
        )) : (
          <tr>
            <td>
              <NoResultsDiv>Not in any teams or course groups</NoResultsDiv>
            </td>
          </tr>
        )}
        </tbody>
      </table>
    </>
  )
}
